import * as types from '../types' 

export function clicouMenu() {
    return {
        type: types.CLICOU_MENU,
        
    }
}

